const key = {
  // 课程状态
  courseStatus: {
    NO: '未开始',
    ON: '进行中',
    CO: '已完成'
  },
  // 课程包状态
  consumeStatus: {
    CONSUMED: '已消耗',
    REBACK: '已返还'
  },
  // leads数据状态
  leadsStatus: {
    NOTLISTEN: '未试听',
    LISTEN: '已试听',
    PAY: '已付费',
    VALID: '有效数据',
    INVALID: '无效数据'
  },
  orgCustomerType: {
    0: '机构',
    2: '学校'
    // 0: '单一机构',
    // 1: '连锁机构',
    // 2: '学校'
  },
  sex: {
    M: '男',
    F: '女'
  },
  userGrade: {
    PRIMARY_SCHOOLE_1: '小学一年级',
    PRIMARY_SCHOOLE_2: '小学二年级',
    PRIMARY_SCHOOLE_3: '小学三年级',
    PRIMARY_SCHOOLE_4: '小学四年级',
    PRIMARY_SCHOOLE_5: '小学五年级',
    PRE_MIDDLE_SCHOOLE: '初中预备班',
    MIDDLE_SCHOOLE_1: '初中一年级',
    MIDDLE_SCHOOLE_2: '初中二年级',
    MIDDLE_SCHOOLE_3: '初中三年级',
    OTHER: '其他'
  },
  intention: {
    HP: '高意向',
    P: '有意向',
    LP: '低意向',
    OKN: '无意向'
  },
  bDataStatus: {
    NOTLISTEN: '未试听',
    LISTEN: '已试听',
    PAY: '已付费',
    VALID: '有效数据',
    INVALID: '无效数据'
  },
  // 激活码状态
  activationStatus: {
    'OFF': '未激活',
    'ON': '使用中',
    'CLOSED': '已作废',
    'EXPIRDE': '已过期'
  }
};
export default key;
